// extracted by mini-css-extract-plugin
module.exports = {"tableDropDown":"notification-options_tableDropDown_1oupD"};